import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRegion } from 'reducers/response';

const useNavExperienceRefresh = (config, fetchFunction) => {
const navigate = useNavigate();
const dispatch = useDispatch();
  useEffect(() => {
    if (config.enable && config.experience_hour_refresh) {
      const refreshTime = (((config.experience_hour_refresh * 60) * 60) * 1000);
      const refreshNav = setInterval(async () => {
        await dispatch(fetchFunction(navigate, null, true));
        if(sessionStorage.getItem('navExperienceChanged') && !window.location.pathname.includes('watch')){
          window.history.pushState(null,'',`/${getRegion()}/${sessionStorage.getItem('navRedirect')}`);
          sessionStorage.removeItem('navExperienceChanged');
          sessionStorage.removeItem('navRedirect');
          window.location.reload();
        }
      }, refreshTime);

      return () => {
        clearInterval(refreshNav);
      };
    }
  }, []);
};

export default useNavExperienceRefresh;